import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { closeConversationAttachmentsSection } from '../../../actions/index';
import {
  SectionContainer,
  LeftSection,
  RightSection,
  ConversationAttachmentsSectionBackToCurrent,
  CloseContainer,
  ConversationAttachmentsButtonGrid,
} from './ConversationAttachmentsSection.styles';
import { getSessionToken } from '../../../util/parseSelectors';
import isEmpty from 'lodash/isEmpty';
import DownloadAttachmentButton from '../DownloadAttachmentButton/DownloadAttachmentButton';
import { isAPIUrl } from '../../../util';

const ConversationAttachmentsSection = ({ mediaUrls }) => {
  const dispatch = useDispatch();
  const [attachmentUrls, setAttachmentUrls] = useState([]);

  useEffect(() => {
    (async () => {
      const token = getSessionToken();

      const preparedMediaUrls = mediaUrls.map((mediaUrl) => {
        if (isAPIUrl(mediaUrl)) {
          const separator = mediaUrl.includes('?') ? '&' : '?';

          return `${mediaUrl}${separator}sessionToken=${token}`;
        }

        return mediaUrl;
      });

      setAttachmentUrls(preparedMediaUrls);
    })();
  }, [mediaUrls]);

  const getNameFromFileSrc = (fileSrc) => {
    const url = new URL(fileSrc);
    try {
      return url.searchParams.get('key').split('/').pop().split(/\d*-/g).pop();
    } catch {
      return url.pathname.split('/').pop();
    }
  };

  return (
    <SectionContainer>
      <LeftSection>
        <ConversationAttachmentsButtonGrid>
          {!isEmpty(attachmentUrls) &&
            attachmentUrls.map((attachment, index) => {
              return <DownloadAttachmentButton label={getNameFromFileSrc(attachment)} url={attachment} key={index} />;
            })}
        </ConversationAttachmentsButtonGrid>
      </LeftSection>
      <RightSection>
        <ConversationAttachmentsSectionBackToCurrent>
          <CloseContainer>
            <img
              alt="hide"
              src="/images/arrows/up-arrow-gray.svg"
              onClick={() => dispatch(closeConversationAttachmentsSection())}
            />
          </CloseContainer>
        </ConversationAttachmentsSectionBackToCurrent>
      </RightSection>
    </SectionContainer>
  );
};

ConversationAttachmentsSection.propTypes = {
  mediaUrls: PropTypes.array,
};

export default ConversationAttachmentsSection;
